const statsTypes = {
  RESET_SUBSCRIPTION_STATE: 'RESET_SUBSCRIPTION_STATE',
  RESET_SUBSCRIPTION_MESSAGE: 'RESET_SUBSCRIPTION_MESSAGE',
  CREATE_SUBSCRIPTION: {
    REQUEST: 'CREATE_SUBSCRIPTION.REQUEST',
    SUCCESS: 'CREATE_SUBSCRIPTION.SUCCESS',
    FAILURE: 'CREATE_SUBSCRIPTION.FAILURE',
  },
  UPDATE_SUBSCRIPTION: {
    REQUEST: 'UPDATE_SUBSCRIPTION.REQUEST',
    SUCCESS: 'UPDATE_SUBSCRIPTION.SUCCESS',
    FAILURE: 'UPDATE_SUBSCRIPTION.FAILURE',
  },
  CANCEL_SUBSCRIPTION: {
    REQUEST: 'CANCEL_SUBSCRIPTION.REQUEST',
    SUCCESS: 'CANCEL_SUBSCRIPTION.SUCCESS',
    FAILURE: 'CANCEL_SUBSCRIPTION.FAILURE',
  },
  FETCH_SUBSCRIPTIONS: {
    REQUEST: 'FETCH_SUBSCRIPTIONS.REQUEST',
    SUCCESS: 'FETCH_SUBSCRIPTIONS.SUCCESS',
    FAILURE: 'FETCH_SUBSCRIPTIONS.FAILURE',
  },
  FETCH_SUBSCRIPTIONS_BY_USER: {
    REQUEST: 'FETCH_SUBSCRIPTIONS_BY_USER.REQUEST',
    SUCCESS: 'FETCH_SUBSCRIPTIONS_BY_USER.SUCCESS',
    FAILURE: 'FETCH_SUBSCRIPTIONS_BY_USER.FAILURE',
  },
};

export default statsTypes;
